<template>
    <div id="investment-experience" class="investment-experience-wrapper pt-8 scroll-mt-56">
        <HeadingBarComponent :step="3" />
        <div class="md:flex">
            <!-- Left Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Years of Experience</h3>
                <InputComponent label="Spot &amp; foreign exchange" :value="submission.investment_experience.foreign_exchange" />
                <InputComponent label="Shares, bonds &amp; funds" :value="submission.investment_experience.shares_bonds_funds" />
                <InputComponent label="Stock &amp; Index Options" :value="submission.investment_experience.stock_index_options" />
                <InputComponent label="Financial &amp; Commodity F &amp; O" :value="submission.investment_experience.financial_commodity" />
                <HrComponent />

                <h3 class="mb-4">Reliant on specific trade recommendations to trade</h3>
                <InputComponent label="Spot &amp; foreign exchange" :value="submission.investment_experience.reliant_on_recommendations_foreign_exchange ? 'Yes' : 'No'" />
                <InputComponent label="Shares, bonds &amp; funds" :value="submission.investment_experience.reliant_on_recommendations_shares_bonds_funds ? 'Yes' : 'No'" />
                <InputComponent label="Stock &amp; Index Options" :value="submission.investment_experience.reliant_on_recommendations_stock_index_options ? 'Yes' : 'No'" />
                <InputComponent label="Financial &amp; Commodity F &amp; O" :value="submission.investment_experience.reliant_on_recommendations_financial_commodity ? 'Yes' : 'No'" />
                <HrComponent />
            </div>
            <!-- Right Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Frequency of Trading within the past 12 months</h3>
                <InputComponent label="Spot &amp; foreign exchange" :value="submission.investment_experience.foreign_exchange_trade_frequency" />
                <InputComponent label="Shares, bonds &amp; funds" :value="submission.investment_experience.shares_bonds_funds_trade_frequency" />
                <InputComponent label="Stock &amp; Index Options" :value="submission.investment_experience.stock_index_options_trade_frequency" />
                <InputComponent label="Financial &amp; Commodity F &amp; O" :value="submission.investment_experience.financial_commodity_trade_frequency" />
                <HrComponent />
            </div>
        </div>
        <div class="px-8">
            <h3 class="mb-4" @click="quickView = !quickView"><span class="icon-chevron mr-2 text-sm" :class="[quickView ? '' : 'active']"></span> Acceptance Criteria</h3>
            <div :class="[quickView ? 'flex' : '']">
                <CheckboxComponent :label="!quickView ? 'I understand the risks of dealing in futures and options, the gearing involved and the potential for loss of capital in excess of my original investment.' : ''" :value="!!submission.investment_experience.understand_capital_loss_risks" />
                <CheckboxComponent :label="!quickView ? 'I understand that small movements in an underlying security/commodity/instrument can result in my transaction incurring much larger profits or losses, and that the more leverage that is available, the greater the effect will be.' : ''" :value="!!submission.investment_experience.understand_small_movements_risks" />
                <CheckboxComponent :label="!quickView ? 'I understand and recognise the potential risks associated in dealing in the markets on which I have experience relating to matters such as settlement, trading, foreign exchange, pricing and costs.' : ''" :value="!!submission.investment_experience.understand_settlement_risks" />
                <CheckboxComponent :label="!quickView ? 'I understand the effect of fees and commissions charges on trading performance.' : ''" :value="!!submission.investment_experience.understand_fees_commissions" />
                <CheckboxComponent :label="!quickView ? 'I understand and recognise the potential risks associated with dealing in options relating to option expiry, assignment and exercise.' : ''" :value="!!submission.investment_experience.understand_options_expiry_risks" />
                <CheckboxComponent :label="!quickView ? 'I understand that it is my responsibility to monitor my account.' : ''" :value="!!submission.investment_experience.understand_responsibility_of_my_account" />
            </div>
            <HrComponent />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from '@adminComponents/misc/HrComponent';
import InputComponent from '@adminComponents/inputs/InputComponent';
import CheckboxComponent from '@adminComponents/inputs/CheckboxComponent';

export default {
    name: "InvestmentExperienceComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
        CheckboxComponent
    },
    computed: {
        ...mapGetters(["submission"])
    },
    data: function () {
        return {
            isLoading: false,
            quickView: true
        };
    },
    methods: {
        // ...mapActions(["doLogout"]),
    },
};
</script>
